import { motion } from "framer-motion";
import { TrendingUp, Handshake, Boxes, Headphones, ArrowUpRight } from "lucide-react";
import { EASE, SectionTag, MaskedLine } from "./Motion";

const services = [
  {
    icon: TrendingUp,
    title: "SMM Precision",
    desc: "Instagram, YouTube, Telegram & X growth engineered to look organic and deliver at machine speed — reach, views, followers, watch hours.",
    span: "md:col-span-7",
    testid: "service-card-smm",
  },
  {
    icon: Handshake,
    title: "Brand Deals",
    desc: "Curated matchmaking between ambitious brands and proven creators. Transparent rates, real contracts, measurable outcomes.",
    span: "md:col-span-5",
    testid: "service-card-brand-deals",
  },
  {
    icon: Boxes,
    title: "Smarter Sourcing",
    desc: "A global supplier network, an ops desk that negotiates hard, and logistics tracked all the way to the doorstep.",
    span: "md:col-span-5",
    testid: "service-card-sourcing",
  },
  {
    icon: Headphones,
    title: "Concierge Support",
    desc: "Humans, not bots — 24/7 across WhatsApp, Telegram and email. Average first response under five minutes, every day of the year.",
    span: "md:col-span-7",
    testid: "service-card-support",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-16">
        <SectionTag index="03" label="Capabilities" testid="services-tag" />
        <h2 className="mt-6 max-w-3xl text-4xl font-bold tracking-tight text-neutral-50 sm:text-5xl">
          <MaskedLine>Precision instruments</MaskedLine>
          <MaskedLine delay={0.12} innerClassName="font-serif italic font-medium text-gold-grad">
            of growth.
          </MaskedLine>
        </h2>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.9, ease: EASE, delay: i * 0.08 }}
                whileHover={{ y: -8 }}
                className={`group relative overflow-hidden rounded-2xl border border-gold/15 bg-panel/80 p-8 backdrop-blur-xl transition-colors duration-500 hover:border-gold/50 sm:p-10 ${s.span}`}
                data-testid={s.testid}
              >
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-gold/[0.08] to-transparent opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
                <div className="relative">
                  <div className="flex items-start justify-between">
                    <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-gold/25 bg-white/[0.03] text-gold transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1">
                      <Icon size={22} strokeWidth={1.75} />
                    </div>
                    <ArrowUpRight
                      size={20}
                      className="text-neutral-600 opacity-0 transition-all duration-500 group-hover:translate-x-1 group-hover:text-gold group-hover:opacity-100"
                    />
                  </div>
                  <h3 className="mt-8 text-2xl font-semibold text-neutral-50">{s.title}</h3>
                  <p className="mt-3 max-w-md text-sm leading-relaxed text-neutral-400 sm:text-base">
                    {s.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
